import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';
import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'

class AdminAddCouponsToInstitution extends Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        institutionsList: [],
        institutionId: '',
        totalCoupon: '',
        availableCoupon: '',
        topupCount: '',
        noCouponError: '',
        mandatoryCheck: ''
      },
      successMsg: '',
      buttonDisable: false,
    }
  }

  componentDidMount() {
    const data = Object.assign({}, this.state.data);
    return api.getInstitutionList(this.props.user.accessToken)
    .then((result) => {
      if(result.status === 'success'){
        data.institutionsList = result.data
      this.setState({data: data})
      }
    })
  }

  handleInstitutionChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.noCouponError = ''
    this.setState({data: data})
    if(event.target.value){
      let selectedOption = event.target.value
      data.institutionId = selectedOption
      var optionElement = event.target.childNodes[event.target.selectedIndex]
    }
    else {
      data.institutionId = ''
    }
    //this.setState({data: data})
    if(data.institutionId) {
      api.getInstitutionCouponDetails(this.props.user.accessToken,data.institutionId)
      .then((result) => {
        if(result.status === 'success'){
          if(result.data === null || result.data === undefined || result.data === '') {
            data.noCouponError = 'No coupon is allocated for this institution'
            data.availableCoupon = ''
            data.totalCoupon = ''
            this.setState({data: data, })
          }
          else {
            data.totalCoupon = result.data.total_allocated_count
            data.availableCoupon = result.data.remaining_count
            this.setState({data: data})
          }
        }
      })
    }
  }

  handleSubmit = (event) => {
    let data = Object.assign({}, this.state.data)
    event.preventDefault()
    data.mandatoryCheck = ''
    this.setState({buttonDisable: true, data: data})
    if((data.topupCount === '') || (data.institutionId === '')) {
      data.mandatoryCheck = 'Institution and Coupon are mandatory.'
      return this.setState({data: data, buttonDisable: false})
    }
    if(data.topupCount <= 0){
      data.mandatoryCheck = 'Coupon count must be greater than 0.'
      return this.setState({data: data, buttonDisable: false})
    }
    let apiInput;

    apiInput = {
      'institution_id': parseInt(data.institutionId),
      'certification_type_id': 4,
      'topup_count': parseInt(data.topupCount),
    }

    api.adminAllocateCoupons(this.props.user.accessToken, apiInput)
    .then((result) => {
      if(result.status === 'success'){
        data.mandatoryCheck = ''
        data.noCouponError = ''
        this.setState({successMsg: result.message, buttonDisable: true,data: data })
      }
      else{
        this.setState({successMsg: result.message, buttonDisable: false})
      }
    })
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  }

  goBack = () => {
    this.props.history.push('/portal/app/admin/coupons')
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
        <Card style={{padding: '25px'}}>
          <Grid>
            <GridCell span="10"><Typography use="headline5">Allocate Coupons to Institutions</Typography></GridCell>
            <GridCell span="2"><Button raised onClick={this.goBack}>Go Back</Button></GridCell>
          </Grid>
          <Grid className="opportunity-list-item">
            <GridCell span="6">
              <div className="full-width">
                <div className="mdc-select" role="listbox">
                  <select 
                    name="testcenter"
                    onChange={this.handleInstitutionChange}
                    value={this.state.data.institutionId}
                    className="mdc-select__native-control two-col-input"
                  >
                    <option value="0" selected="">--Select Institution--</option>
                    {this.state.data.institutionsList.map(institution => (
                      <option key={institution.id} value={institution.id} data-name={institution.name} track-amount={institution.amount}>
                        {institution.name} 
                      </option>
                    ))}
                  </select>
                  <label className="mdc-floating-label mdc-floating-label--float-above">Institution Name</label>
                  <div className="mdc-line-ripple"></div>
                </div>
              </div>
            </GridCell>
            <GridCell span="6"></GridCell>
            {this.state.data.noCouponError?<GridCell span="12"><StatusMessage error_msg = {this.state.data.noCouponError}/></GridCell>: null}
            <GridCell span="6">
              <TextField fullwidth className='text_input' label="Total Coupon" autoComplete="off" name="totalCoupon" onChange={this.onInputChange} value={this.state.data.totalCoupon} disabled/>
            </GridCell>
            <GridCell span="6"></GridCell>
            
            <GridCell span="6">                  
              <TextField fullwidth className='text_input' label="Available Coupon" autoComplete="off"  name="availableCoupon" onChange={this.onInputChange} value={this.state.data.availableCoupon} disabled/>
            </GridCell>
            <GridCell span="6"></GridCell>

            <GridCell span="6">                  
              <TextField fullwidth type = "number" className='text_input' label="Add Coupon" autoComplete="off"  name="topupCount" onChange={this.onInputChange} value={this.state.data.topupCount}/>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <Button raised disabled={this.state.buttonDisable}>Add Coupons</Button>
            </GridCell>
            {this.state.data.mandatoryCheck?<GridCell span="12"><StatusMessage error_msg = {this.state.data.mandatoryCheck}/></GridCell>: null}
            <GridCell span="12"><StatusMessage error_msg = {this.state.successMsg}/></GridCell> 
          </Grid>
        </Card>
      </form>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAddCouponsToInstitution);


// WEBPACK FOOTER //
// ./src/views/admin/AdminAddCouponsToInstitution.jsx